const getImageDimensions = ({ height, width }) => ({
  ...(height && { height }),
  ...(width && { width }),
});

export default getImageDimensions;
